import { useEffect, useState } from 'react'
import AnimatedSection from '../common/AnimatedSection'
import { inquiryFormSection, quoteFormSection } from '../../data/contactPageData'
import ContactFormIntro from './ContactFormIntro'
import ContactFormPanel from './ContactFormPanel'

const FORM_TABS = [
  {
    id: 'quote',
    hash: 'quote-form',
    tabLabel: 'Get A Quote',
    section: quoteFormSection,
    formType: 'quote',
  },
  {
    id: 'inquiry',
    hash: 'inquiry-form',
    tabLabel: 'General Inquiry',
    section: inquiryFormSection,
    formType: 'inquiry',
  },
]

const HASH_TO_TAB = Object.fromEntries(FORM_TABS.map((tab) => [tab.hash, tab.id]))

function ContactFormsTabsSection() {
  const [activeTab, setActiveTab] = useState('quote')

  useEffect(() => {
    const syncTabFromHash = () => {
      const hash = window.location.hash.replace('#', '')
      if (HASH_TO_TAB[hash]) {
        setActiveTab(HASH_TO_TAB[hash])
      }
    }

    syncTabFromHash()
    window.addEventListener('hashchange', syncTabFromHash)
    return () => window.removeEventListener('hashchange', syncTabFromHash)
  }, [])

  const handleTabChange = (tabId) => {
    const tab = FORM_TABS.find((item) => item.id === tabId)
    if (!tab) return

    setActiveTab(tabId)
    const nextHash = `#${tab.hash}`
    if (window.location.hash !== nextHash) {
      window.history.replaceState(null, '', nextHash)
    }
  }

  const activeConfig = FORM_TABS.find((tab) => tab.id === activeTab) || FORM_TABS[0]

  return (
    <AnimatedSection className="contact-forms-tabs contact-form-block">
      <span id="quote-form" className="contact-forms-tabs__anchor" aria-hidden="true" />
      <span id="inquiry-form" className="contact-forms-tabs__anchor" aria-hidden="true" />

      <div className="container corp-container">
        <div
          className="contact-forms-tabs__bar"
          role="tablist"
          aria-label="Contact forms"
        >
          {FORM_TABS.map((tab) => {
            const isActive = activeTab === tab.id
            return (
              <button
                key={tab.id}
                type="button"
                role="tab"
                id={`contact-tab-${tab.id}`}
                className={`contact-forms-tabs__tab${isActive ? ' is-active' : ''}`}
                aria-selected={isActive}
                aria-controls={`contact-panel-${tab.id}`}
                onClick={() => handleTabChange(tab.id)}
              >
                {tab.tabLabel}
              </button>
            )
          })}
        </div>

        <div className="contact-form-block__wrap">
          <ContactFormIntro section={activeConfig.section} />

          <div className="contact-forms-tabs__panels">
            {FORM_TABS.map((tab) => {
              const isActive = activeTab === tab.id
              return (
                <div
                  key={tab.id}
                  id={`contact-panel-${tab.id}`}
                  role="tabpanel"
                  className="contact-forms-tabs__panel"
                  aria-labelledby={`contact-tab-${tab.id}`}
                  hidden={!isActive}
                >
                  {isActive ? (
                    <ContactFormPanel
                      section={tab.section}
                      formId={tab.hash}
                      formType={tab.formType}
                    />
                  ) : null}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </AnimatedSection>
  )
}

export default ContactFormsTabsSection
